import { Booking } from '../../../../entities/booking';
import { CancelBookingPage } from '../cancel-booking/cancel-booking';
import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { SpinnerDialog } from '@ionic-native/spinner-dialog';
import { Api } from '../../../../providers/api';

@Component({
    selector: 'page-view-booking',
    templateUrl: 'view-booking.html',
})
export class ViewBookingPage {

    booking: Booking = new Booking();

    constructor(
        private api: Api,
        private navCtrl: NavController,
        private navParams: NavParams,
        private spinner: SpinnerDialog,
    ) {
    }

    ngAfterViewInit() {
        this.booking = this.navParams.get('booking');
    }

    get statusType(): string {
        if (this.booking.status === undefined) return undefined;
        switch (this.booking.status.toLowerCase()) {
            case 'shipped':
                return 'pink';
            case 'confirmed':
                return 'success';
            case 'pending':
            case 'standby':
                return 'warning';
            case 'cancelled':
                return 'danger';
        }
        return undefined;
    }

    statusMessage(): string {
        if (this.booking.status === undefined) return '';
        return 'BOOKING ' + this.booking.status.toUpperCase();
    }

    get isCancellable(): boolean {
        if (this.booking === undefined || this.booking.status === undefined) return false;
        switch (this.booking.status.toLowerCase()) {
            case 'pending':
            case 'confirmed':
                return true;
        }
        return false;
    }

    async cancelBooking() {
        this.spinner.show();
        this.navCtrl.push(CancelBookingPage, {booking: this.booking});
        this.spinner.hide();
    }

    async refreshPage(refresher) {
        if (this.booking === undefined) return;
        this.booking = await this.api.getMyBooking(this.booking);
        refresher.complete();
    }
}



// WEBPACK FOOTER //
// ./src/pages/bookings/my-bookings/view-booking/view-booking.ts